import { type LegalDocument, type LegalDocumentsResponse } from '@/modules/api';

// Returns the documents the user still owes a signature on. Honors BOTH
// gates the server provides:
//   - Top-level `needToSign`: master switch. When false (e.g. already-signed
//     users), drop everything regardless of per-doc flags.
//   - Per-doc `needToSign`: per-item filter. Drop docs the user has signed.
//
// Mirrors Sparta's useLegalDocuments. An empty array is the legitimate
// "nothing to show" outcome — callers should render zero checkboxes, not
// error.
export function selectSignableDocuments(response: LegalDocumentsResponse): LegalDocument[] {
  if (!response.needToSign) return [];
  return response.documents.filter((d) => d.needToSign);
}
